<template>
	<div class="form-options-group" :class="opt.classAdd" v-if="typeof opt.collapse == 'undefined'" 
						v-loading.fullscreen.lock="this.fullscreenLoading"
						element-loading-text="Загрузка данных..."
						element-loading-spinner="el-icon-loading"
						element-loading-background="rgba(0, 0, 0, 0.8)"				>
		<h4 class="title" v-if="!isCollapseItem && (typeof opt.blockTitle !='undefined' && opt.blockTitle !='')">{{ opt.blockTitle }}</h4>
		<div
			v-for="(element,main_el_index) in opt.elements"
			:key="main_el_index" 
			:class="[{'d-none':(element.auto_hidden == true && element.auto_show != true)}]"
			class="elementWrapper"
			:ref="element.elementGetParamMap"
			>
		 	<!-- v-if="(element.auto_hidden == true && !element.auto_show)" -->
			<!--pre>{{main_el_index}} , {{element}}</pre-->
			{{CheckOption(element)}}
			<div
				v-if="isCheckList && (typeof element.checklist != 'undefined')"
				class="check-list"
				:class="[{'formRequired':element.required===true},{'hidden':element.elementType === 'label'}, {'d-none': element.elementType === 'hidden-input'}]">
					<base-checkbox :checked="element.checklist.element_model" v-model="element.checklist.element_model" inline></base-checkbox>
			</div>

			<div v-if="(typeof element.required!='undefined') && element.canSkip && (typeof element.canSkip_model!='undefined')">
				<div class="col-md-12 checkbox-radios">
					<base-checkbox :checked="element.canSkip_model" v-model="element.canSkip_model" inline @input="canSkip_change(element)">{{element.canSkip_label?element.canSkip_label:'пропустить'}}</base-checkbox>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'label' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<div class="px-3"><h6 class="d-inline">{{element.placeholder}}</h6><label class="col-form-label" v-if="element.element_model!=''">: {{element.element_model}}</label></div>
			</div>

			<input v-if="element.elementType == 'input-hidden' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" type="hidden" v-model="element.element_model"  :ref="element.elementGetParamMap" :id="element.elementGetParamMap">

			<FormElementWrapper v-if="element.elementType == 'input' && (element.contr==undefined || contr(element))"
				:element="element"
				>
				<input
					:type="typeof element.type != 'undefined'?element.type:'text'"
					:findId="element.elementGetParamMap"
					:placeholder="element.placeholder"
					class="form-control" v-model.lazy="element.element_model"
					:required="$GVO.toBool(element.required)"
					:disabled="typeof element.disabled != 'undefined'? element.disabled:false" 
					/>
			</FormElementWrapper>
			<!--
			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''"> <span>{{ element.label }}</span> <span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="col-md-12 form-group" :class="[element.required===true?'required':'']">
						<div class="mb-0">
							<input :type="typeof element.type != 'undefined'?element.type:'text'" :findId="element.elementGetParamMap" :placeholder="element.placeholder" class="form-control" v-model.lazy="element.element_model" :required="$GVO.toBool(element.required)">
						</div>
					
				</div>
			</div>
			-->
			<FormElementWrapper v-if="element.elementType == 'input-mask' && (element.contr==undefined || contr(element))"
				:element="element"
				>
				<ReInputMask
					:mask="element.mask"
					:findId="element.elementGetParamMap"
					:placeholder="element.placeholder"
					v-model="element.element_model"
					:required="$GVO.toBool(element.required)"
				/>
			</FormElementWrapper>
			<!--
			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-mask' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="col-md-12">
					<div :class="[{'form-group':true,'required':element.required===true}]">
						<div class="mb-0">
							<ReInputMask :mask="element.mask" :findId="element.elementGetParamMap" :placeholder="element.placeholder" v-model="element.element_model" :required="$GVO.toBool(element.required)"/>
						</div>
					</div>
				</div>
			</div>
			-->
			<FormElementWrapper v-if="element.elementType == 'input-number' && (element.contr==undefined || contr(element))"
				:element="element"
				>
				<input
					type="number"
					pattern="[0-9]+"
					:findId="element.elementGetParamMap"
					:placeholder="element.placeholder"
					class="form-control"
					v-model.lazy="element.element_model"
					:required="$GVO.toBool(element.required)"
					onwheel="return false;"
					:min = "element.minValue"
					:max = "element.maxValue"
					@blur="fixNumber(element)"
				/>
			</FormElementWrapper>

			<FormElementWrapper v-if="element.elementType == 'color-picker' && (element.contr==undefined || contr(element))"
				:element="element"
				>
				<el-color-picker v-model.lazy="element.element_model"></el-color-picker>
			</FormElementWrapper>

			<!-- <div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-number' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" ><span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="col-md-12">
					<div :class="[{'form-group':true,'required':element.required===true}]">
						<div class="mb-0">
							<input
								type="number"
								pattern="\d+"
								:findId="element.elementGetParamMap"
								:placeholder="element.placeholder"
								class="form-control"
								v-model.lazy="element.element_model"
								:required="$GVO.toBool(element.required)"
								onwheel="return false;"
								:min = "element.minValue"
								:max = "element.maxValue"
								@blur="fixNumber(element)"
							/>
						</div>
					</div>
				</div>
			</div> -->

			<FormElementWrapper v-if="element.elementType == 'textarea' && (element.contr==undefined || contr(element))"
				:element="element"
				>
				<textarea class="form-control" :findId="element.elementGetParamMap" :required="$GVO.toBool(element.required)" v-model.lazy="element.element_model" :placeholder="element.placeholder" @change="change(element)"></textarea>
			</FormElementWrapper>

			<!-- <div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'textarea' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span> <span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="col-md-12">
					<div class="form-group" :class="[element.required===true?'required':'']">
						<div class="mb-0">
							<textarea class="form-control" :findId="element.elementGetParamMap" :required="$GVO.toBool(element.required)" v-model.lazy="element.element_model" :placeholder="element.placeholder" @change="change(element)"></textarea>
						</div>
					</div>
				</div>
			</div> -->

			<FormElementWrapper v-if="element.elementType == 'textarea-descr' && (element.contr==undefined || contr(element))"
				:element="element"
				>
				<textarea class="form-control" :findId="element.elementGetParamMap" :required="$GVO.toBool(element.required)" v-model.lazy="element.element_model" :placeholder="element.placeholder" @change="change(element)"></textarea>
				<div>
					<p class="DescrNumber" >Количество символов: {{ element.element_model.length }}</p>
				</div>
			</FormElementWrapper>



			<!-- <div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'textarea-descr' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''"> <span>{{ element.label }}</span> <span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="col-md-12">
					<div :class="[{'form-group':true,'required':element.required===true}]">
						<div class="mb-0">
							<textarea class="form-control" :findId="element.elementGetParamMap" :required="$GVO.toBool(element.required)" v-model.lazy="element.element_model" :placeholder="element.placeholder" @change="change(element)"></textarea>
						</div>
						<p class="DescrNumber" >Количество символов: {{ element.element_model.length }}</p>
					</div>
				</div>
			</div> -->

			<FormElementWrapper v-if="element.elementType == 'textarea-popover' && (element.contr==undefined || contr(element))"
				:element="element"
				>
				<el-popover
					placement="top-start"
					:title="element.pop_title"
					width="320"
					trigger="hover"
					:content="element.pop_content">
						<!--
						<textarea slot="reference" class="form-control" :findId="element.elementGetParamMap" :required="$GVO.toBool(element.required)" v-model.lazy="element.element_model" :placeholder="element.placeholder" @change="change(element)"></textarea>
						-->
						<template v-slot:reference>
							<textarea class="form-control" :findId="element.elementGetParamMap" :required="$GVO.toBool(element.required)" v-model="element.element_model" :placeholder="element.placeholder" @change="change(element)"></textarea>
						</template>
					</el-popover>
			</FormElementWrapper>

			<!-- <div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'textarea-popover' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span> <span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="col-md-12">
					<div :class="[{'form-group':true,'required':element.required===true}]">
						<div class="mb-0">
							<el-popover
							placement="top-start"
							:title="element.pop_title"
							width="320"
							trigger="hover"
							:content="element.pop_content">
								<template v-slot:reference><textarea class="form-control" :findId="element.elementGetParamMap" :required="$GVO.toBool(element.required)" v-model.lazy="element.element_model" :placeholder="element.placeholder" @change="change(element)"></textarea></template>
							</el-popover>
						</div>
					</div>
				</div>
			</div> -->

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'radio-group' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" ><span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="col-md-12 checkbox-radios">
					<base-radio
						v-for="(el_opt, el_index) in element.options"
						:key="el_opt.name+'_'+el_index"
						:name="el_opt.name"
						v-model="element.element_model"
						inline
						@input="change(element)"
						>{{el_opt.label}}</base-radio>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-contact' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<!-- <label class="col-form-label col-md-12" :class="[{'formRequiredSpec':(element.contactGroup ==='phone')}, ]" v-if="typeof element.label !='undefined' && element.label !=''">
					<span>{{ element.label }}</span>
				</label> -->
				<div class="col-md-12 form-group"  :class="[element.required===true?'required':'']">
					<ReInputContact 
						:findId="element.elementGetParamMap"
						:copyFrom="element.copyFrom"
						v-model="element.element_model" 
						:contactGroup_options="element.contactGroup_options" 
						:contactGroup="element.contactGroup"
						:placeholder="element.placeholder"
						:errorLabel="element.label"
						:label="element.label"
						:delMethod="element.delMethod"
						:required="$GVO.toBool(element.required)"
						:bShowView="element.bShowView"
						:bShowCallBtn="element.bShowCallBtn"
						:bShowAddBtn="element.bShowAddBtn"
						:bCheckClient="element.bCheckClient"
						:isCallCenter="element.isCallCenter"
						:saveClientFio="element.saveClientFio"
						:beforeCall="element.beforeCall"
					/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'select' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" ><span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="col-md-12 d-flex" style="align-items: center;" :class="[{'form-group':true,'required':element.required===true}]">
					<el-select
						class="w-100 select-primary "
						size="large"
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						v-model="element.element_model"
						:filterable="typeof element.filterable == 'undefined' ? false : element.filterable"
						:multiple="typeof element.multiple == 'undefined' ? false : element.multiple"
						:required="$GVO.toBool(element.required)"
						@change="change(element)"

					>
						<el-option
							v-for="(el_opt, el_index) in element.options"
							class="select-primary"
							:value="el_opt.value"
							:label="el_opt.label"
							:key="el_index"
						>
						</el-option>
					</el-select>
					<base-button v-if="element.required == false && (typeof element.multiple == 'undefined' ? true : !element.multiple)" type="danger" class="no-border my-0" simple icon @click="$set(element,'element_model',''); change(element);"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
				
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'select-tree' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<ReTreeSearchDrop 
					:findId="element.elementGetParamMap"
					class="col-md-12 select-primary"
					:name="element.elementGetParamMap"
					:placeholder="element.placeholder"
					:strType="element.strType"
					v-model="element.element_model"
					@change="change(element)"
				/>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-date-range' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" ><span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReDateRange 
						:findId="element.elementGetParamMap"
						:range_separator="element.range_separator"
						:start_placeholder="element.start_placeholder"
						:end_placeholder="element.end_placeholder"
						:type="element.type"
						v-model="element.element_model"
					/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-date' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<el-date-picker
						:findId="element.elementGetParamMap"
						type="date"
						format="dd.MM.yyyy"
						value-format="yyyy-MM-dd"
						:default-value="element.defaultvalue"
						:placeholder="element.placeholder"
						:picker-options="{firstDayOfWeek:1}"						
						v-model="element.element_model"
					>
					</el-date-picker>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-datetime' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" ><span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<el-date-picker
						:findId="element.elementGetParamMap"
						type="datetime"
						format="dd.MM.yyyy HH:mm:ss"
						value-format="yyyy-MM-dd HH:mm:ss"
						:default-time="element.defaultTime"
						:placeholder="element.placeholder"
						:picker-options="{firstDayOfWeek:1}"						
						v-model="element.element_model"
					>
					</el-date-picker>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-time' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span> <span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<base-input>
						<el-time-select 
							:findId="element.elementGetParamMap"
							:placeholder="element.placeholder" 
							v-model="element.element_model"
							:picker-options="{start: '08:00',step: '00:30',end: '23:30',format:'HH:mm:ss'}"
							
						>
						</el-time-select>
					</base-input>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-time-range' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReTimeRange 
						:findId="element.elementGetParamMap"
						:range_separator="element.range_separator"
						:start_placeholder="element.start_placeholder"
						:end_placeholder="element.end_placeholder"
						v-model="element.element_model"
					/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'checkbox' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.placeholder !='undefined' && element.placeholder !=''" > <span>{{ element.placeholder }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="col-md-12 checkbox-radios">
					<base-checkbox :findId="element.elementGetParamMap" :checked="element.element_model" v-model="element.element_model" inline @input="change(element)">{{element.label}}</base-checkbox>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" 
				v-if="element.elementType == 'checkbox-group' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" ><span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="col-md-12 checkbox-radios">
					<base-checkbox v-for="el_opt in element.options" 
					:checked="element.element_model[el_opt.key]" 
					v-model="element.element_model[el_opt.key]" 
					:disabled="typeof el_opt.disabled != 'undefined'? el_opt.disabled:false" 
					:key="el_opt.key" 
					:inline="element.inline"
					>{{el_opt.label}}</base-checkbox>
				</div>
				<p class="col-form-label col-md-12" v-if="typeof element.zero_options !='undefined' && element.zero_options !=''">{{element.zero_options}}</p>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'switcher' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.placeholder }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<base-switch
						:findId="element.elementGetParamMap"
						v-model="element.element_model"
						type="primary"
						:on-text="element.label_on"
						:off-text="element.label_off"
					></base-switch>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'list' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReBranchTree :findId="element.elementGetParamMap" :tree-data="element.element_model"/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'task-ends' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReTaskEnds 
						:findId="element.elementGetParamMap" 
						v-model="element.element_model" 
						:type_options="element.type_options" 
						:next_options="element.next_options" 
						:tType_options="element.tType_options"
						:checklist_options="element.checklist_options"
						:servicelist_options="element.servicelist_options"
						:vcard_popover="element.vcard_popover"
						/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-actions' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReActionInput 
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						v-model="element.element_model" 
						:masActions="element.action_options"/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'upload-docs' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReUploadDocs 
						:findId="element.elementGetParamMap"
						v-model="element.element_model" 
						:limit="element.limit"/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'file-upload' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12 pb-1" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<label class="col-form-label col-md-12 pt-0" v-if="typeof element.placeholder !='undefined' && element.placeholder !=''"> <span>{{ element.placeholder }}</span></label>
				<div class="form-group col-md-12">
					<ReFileUpload 
						:findId="element.elementGetParamMap"
						v-model="element.element_model"
						:type="element.type"
						:multiple="element.multiple"
						:formId="(typeof element.formId == 'undefined'?'UploadForm'+'_'+Math.random():element.formId)+'_'+main_el_index"
						:btnClass="element.btnClass"
						:bShowTrash="element.bShowTrash"
						:bshowClipboard="element.bshowClipboard"
						:acceptMime="element.acceptMime"
						:uploadApi="element.uploadApi"
						:delApi="element.delApi"
						:src_filenames="(typeof element.src_filenames == 'undefined'?[]:element.src_filenames)"
						v-on:change="OnUploadFile"
						v-on:clear="element.element_model=[];"
						:additionalInfo="element.additionalInfo"
						:help="element.help"
						/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'image-upload' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12 pb-1" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<label class="col-form-label col-md-12 pt-0" v-if="typeof element.placeholder !='undefined' && element.placeholder !=''"> <span>{{ element.placeholder }}</span></label>
				<div class="form-group col-md-12">
					<ReImagesUpload 
						:findId="element.elementGetParamMap"
						v-model="element.element_model"
						:type="element.type"
						:multiple="element.multiple"
						:formId="(typeof element.formId == 'undefined'?'imgUploadForm'+'_'+Math.random():element.formId)+'_'+main_el_index"
						:btnClass="element.btnClass"
						:bShowTrash="element.bShowTrash"
						:bshowClipboard="element.bshowClipboard"
						:acceptMime="element.acceptMime"
						:uploadApi="element.uploadApi"
						:delApi="element.delApi"
						:src_filenames="(typeof element.src_filenames == 'undefined'?[]:element.src_filenames)"
						v-on:change="OnUploadFile"
						v-on:clear="element.element_model=[];"
						:additionalInfo="element.additionalInfo"
						:help="element.help"
						/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'passport-upload' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<RePassportPhotos 
						:findId="element.elementGetParamMap"
						v-model="element.element_model"
						:uploadApi="element.uploadApi"
						:delApi="element.delApi"
						:strFilePath="element.strFilePath"
						:strGetMethod="element.strGetMethod"
						:state="element.state"
					/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'ajax-list' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="col-md-12 d-flex" style="align-items: center;">
					<ReInputSearchDrop 
							:findId="element.elementGetParamMap"
							:name="element.name"
							:placeholder="element.placeholder"
							v-model="element.element_model"
							:objApiMethod="element.objApiMethod"
							:strApiMethodKey="element.strApiMethodKey"
							:strType="element.strType"
							v-on:change="OnAjaxListSearch"
						/>
					<base-button type="danger" class="no-border my-0" simple icon @click="element.element_model = {'inputText':'','selectedVal':''}"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'ajax-list-tags' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReTagGroupList
						v-model="element.element_model"
						:name="element.name"
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						:objApiMethod="element.objApiMethod"
						:strApiMethodKey="element.strApiMethodKey"
						:strType="element.strType"
						:objSaveApiMethod="element.objSaveApiMethod"
					/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'fromMetro' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReFromMetro 
						:findId="element.elementGetParamMap"
						v-model="element.element_model" 
						:placeholder="element.placeholder"
						:options="element.options"/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'urgency' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReUrgency 
						:findId="element.elementGetParamMap"
						v-model="element.element_model" 
						:options_buy="element.options_buy"
						:options_keys="element.options_keys"/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'place' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" ><span>{{ element.label }} </span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<RePlace 
						:findId="element.elementGetParamMap"
						v-model="element.element_model" />
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 're-curator' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" ><span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReCurator 
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						v-model="element.element_model"
						:objStaff="element.objStaff"
						:options="element.options"/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'show-clientmobile' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReShowClientMobile 
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						:client_id="element.client_id"
						v-model="element.element_model" />
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'select-cascade' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="(element.required===true) || (element.elementGetParamMap ==='gk_data')" class="hohoho">*обязательно</span></label>
				<div class="form-group SelectCascade-col px-3"> 
					<ReSelectCascade
						:findId="element.elementGetParamMap"
						v-model="element.element_model" />
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'select-cascade-arman-nb' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="(element.required===true) || (element.elementGetParamMap ==='arman_gk_data')" class="hohoho">*обязательно</span></label>
				<div class="form-group SelectCascade-col px-3"> 
					<ReSelectCascadeArmanNB 
						:findId="element.elementGetParamMap"
						v-model="element.element_model" />
				</div>
			</div>
			
			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-amount' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReInputAmount 
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						v-model="element.element_model" />
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-decimal' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReInputDecimal
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						v-model="element.element_model" />
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-inn' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" ><span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReInputINN 
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						v-model="element.element_model" />
				</div>
			</div>
			
			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-innur' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReInputINNUr
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						v-model="element.element_model" />
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-snils' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''"  ><span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReInputSNILS 
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						v-model="element.element_model" />
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-ajaxsearch-distrmetro' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReInputSearchDistrMetro 
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						v-model="element.element_model"/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'select-sovmest-service' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReSelectSovmestService 
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						v-model="element.element_model"
						:objApiMethod="element.objApiMethod"
						:strApiMethodKey="element.strApiMethodKey"/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'select-blank-service' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReSelectBlankServices
						v-model="element.element_model"
					/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'staff-notify-conf' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReStaffNotifyConf 
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						v-model="element.element_model"
						:showTitle="element.show_title"
						/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'staff-notify-list' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReStaffNotificationList 
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						:checkboxes="element.checkboxes"
						v-model="element.element_model"/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'reassign-ext-calls' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReReassignExtCalls 
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						v-model="element.element_model"/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'list-of-people' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReListOfPeople 
						:findId="element.elementGetParamMap"
						v-model="element.element_model"
						:contactPhone_options="element.contactPhone_options"
						:contactEmail_options="element.contactEmail_options"
						/>
				</div>
			</div>
			
			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'list-of-bronflats' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<div class="form-group col-md-12">
					<ReFlatListForBron 
						:findId="element.elementGetParamMap"
						:service_id="element.service_id"
						@applyBronFields="OnBronFields"
						/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'fio-padej' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" ><span>{{ element.label }} </span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group d-flex col-md-12">
					<ReFioPadej
						:findId="element.elementGetParamMap"
						:required="element.required"
						v-model="element.element_model"
						:externalParamsValue="element.external_params_value"
						@change="change(element)"
						/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'passport-full' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<RePassportFull
						:findId="element.elementGetParamMap"
						v-model="element.element_model" />
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'client-address' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReClientAddress
						:findId="element.elementGetParamMap"
						:clientType="element.clientType"
						v-model="element.element_model" />
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-bicur' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReInputBICUr
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						v-model="element.element_model" />
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'map-editor' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''"> <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReCellMapEditor
						:findId="element.elementGetParamMap"
						v-model="element.element_model" />
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'select-objcat' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReSelectCascadeObjCategory
						:findId="element.elementGetParamMap"
						v-model="element.element_model"
					/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'map-address' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReMapAddress
						:findId="element.elementGetParamMap"
						v-model="element.element_model"
						:settings="element.settings"
						:zoom="element.zoom"
						:controls="element.controls"
						:required="$GVO.toBool(element.required)"
						:flatNumPlaceholder="element.flatNumPlaceholder"
						:objectType="element.objectType"
						@input="change(element)"
					/>
				</div>
			</div>
			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'map-location' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReMapLocation
						:findId="element.elementGetParamMap"
						v-model="element.element_model"
						:settings="element.settings"
						:zoom="element.zoom"
						:controls="element.controls"
						:required="$GVO.toBool(element.required)"
						@input="change(element)"
					/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'rating' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<el-rate
						:findId="element.elementGetParamMap"
						v-model.lazy="element.element_model"
						type="number"
						:required="$GVO.toBool(element.required)"
						:icon-classes="['ics-rate-face-1', 'ics-rate-face-2', 'ics-rate-face-3']"
						void-icon-class="ics-rate-face-off"
						:colors="['#99A9BF', '#F7BA2A', '#FF9900']"
						show-text
						:texts="['oops', 'disappointed', 'normal', 'good', 'great']"
					></el-rate>

				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'contact-drawer' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReContactMessangersTemplate
						:findId="element.elementGetParamMap"
						:text="element.text"
						:contacts="element.contacts" 
						:masCalls="element.masCalls" />
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'cell-address' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReCellByAddr
						:findId="element.elementGetParamMap"
						v-model="element.element_model"
						:options="element.options"
					/>
				</div>
			</div>

			<div v-if="element.elementType == 'checklist-fields' && (element.contr==undefined || contr(element))" class="row px-1" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReCheckListFields
						v-model="element.element_model"
						:options="element.options"
					/>
				</div>
			</div>
			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'lead-search-obj' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReLeadSearchObj
						:findId="element.elementGetParamMap"
						v-model="element.element_model"
						:placeholder="element.placeholder"
						@input="change(element)"
						/>
				</div>
			</div>
			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'messengers-template' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="col-md-12">
					<div class="form-group ">
						<ReMessengersTemplate
							:findId="element.elementGetParamMap"
							:placeholder="element.placeholder" 
							v-model="element.element_model"
							:externalParamsValue="element.external_params_value"
							/>
					</div>
				</div>
			</div>
			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'lead-call-cat' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReLeadCallCat
						:findId="element.elementGetParamMap"
						:leadId="element.leadId"
						v-model="element.element_model"
						@input="change(element)"
						@OnIsObjects="OnIsObjects"
						:isObjects="element.isObjects"
						:placeholder="element.placeholder"
						:required="element.required"
						:externalParamsValue="element.external_params_value" />
				</div>
			</div>
			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'square-cost' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12"  v-if="typeof element.label !='undefined' && element.label !=''"><span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="col-md-12">
					<ReSquareCost 
						:findId="element.elementGetParamMap"
						v-model="element.element_model" 
					/>
				</div>
			</div>
			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'share-percent' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''"><span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="col-md-12">
					<ReSharePercent 
						:findId="element.elementGetParamMap"
						v-model="element.element_model" 
					/>
				</div>
			</div>
			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'select-railway' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12"  v-if="typeof element.label !='undefined' && element.label !=''"><span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div  class="col-md-12 d-flex" style="align-items: center;">
					<!-- {{element}} -->
					<ReInputRailway
						:findId="element.elementGetParamMap"
						v-model="element.element_model" 
						:region="element.region"
						v-bind:externalParamsValue="element.external_params_value"

					/>
					<base-button v-if="typeof element.multiple == 'undefined' ? true : !element.multiple" type="danger" class="no-border my-0" simple icon @click="element.element_model = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>

				</div>

			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'select-region-district' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12"  v-if="typeof element.label !='undefined' && element.label !=''"><span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div  class="col-md-12 d-flex" style="align-items: center;">
					<!-- {{element}} -->
					<ReSelectRegionDistrict
						:findId="element.elementGetParamMap"
						v-model="element.element_model" 
					/>
					<!-- <base-button v-if="typeof element.multiple == 'undefined' ? true : !element.multiple" type="danger" class="no-border my-0" simple icon @click="function(){element.element_model = '';}"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button> -->

				</div>

			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'lead-services' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12"  v-if="typeof element.label !='undefined' && element.label !=''"><span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="col-md-12">
					<ReLeadServices
						:findId="element.elementGetParamMap"
						v-model="element.element_model" 
						:client_phone="element.client_phone" 
					/>
				</div>
			</div>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-roomsum' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReInputRoomSum
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						:roomSum="element.roomSum"
						@input="change(element)"
						v-model="element.element_model" />
				</div>
			</div>
			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-usefulSquare' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReUsefulSquare
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						v-model="element.element_model" 
						v-bind:externalParamsValue="element.external_params_value"
						:min = "element.minValue"
						:max = "element.maxValue"
						/>
				</div>
			</div>
			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'select-scheduleServices' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<ReSelectScheduleServices
						:findId="element.elementGetParamMap"
						:placeholder="element.placeholder"
						:multi_service="element.multi_service"
						:hide_rb_service="element.hide_rb_service"
						v-model="element.element_model" 
						/>
				</div>
			</div>
			<!--
			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'input-basedatetime' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<BaseDateTimePicker
						:findId="element.elementGetParamMap"
						:type="element.type"
						:daterestriction="element.daterestriction"
						v-model="element.element_model" 
						/>
				</div>
			</div>
			-->
			<FormElementWrapper v-if="element.elementType == 'input-basedatetime' && (element.contr==undefined || contr(element))"
				:element="element"
				>
				<BaseDateTimePicker
						:findId="element.elementGetParamMap"
						:type="element.type"
						:daterestriction="element.daterestriction"
						v-model="element.element_model" 
						/>
			</FormElementWrapper>

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'presentaion-myobj-button' && (element.contr==undefined || contr(element))" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<label class="col-form-label col-md-12" v-if="typeof element.label !='undefined' && element.label !=''" > <span>{{ element.label }}</span><span v-if="element.required===true" class="hohoho">*обязательно</span></label>
				<div class="form-group col-md-12">
					<RePresentaionMyObjButton
						:findId="element.elementGetParamMap"
						:type="element.type"
						:taskend_id="element.taskend_id"
						:task_id="element.task_id"
						:service_id="element.service_id"
						:client_id="element.client_id"
						:object_id="element.object_id"
						v-model="element.element_model" 
						/>
				</div>
			</div>

			<FormElementWrapper v-if="element.elementType == 'marketing-export' && (element.contr==undefined || contr(element))"
				:element="element"
				>
				<ReMarketingExport
					v-model="element.element_model" 
					/>
			</FormElementWrapper>			

			<div class="row" :class="[{'d-none':element.elementVisibility && element.elementVisibility=='none'}]" v-if="element.elementType == 'HELP'" :key="element.elementGetParamMap+'_'+main_el_index" :ref="element.elementGetParamMap" :id="element.elementGetParamMap">
				<pre>
					Описание ПРОПСов для FormPrinter:
						- masFormConfig				[Array]		Массив объектов описания полей
						- objFormData				[Object]	Depricated Атавизм, данные для предзаполнения полей
						- objSaveApiMethod			[Object]	Описание метода для сохранения данных формы
							такого формата {apiMethod:'UPD_CONTACT',apiParam:{obj:'staff' ,flt:{code:this.objStaff.code},uData:[]}}
						- objSaveApiMethodDataParam		[String]	Параметр в который сгруппировать данные формы - !!! не до конца продумано !!!
						- SuccessGo				[Function]	Функция вызывается когда данные успешно отданы в АПИ. В неё передаётся location.pathname
					FormPrinter ничего не возвращает, только вызывает SuccessGo при успехе, по-этому SuccessGo обязательный параметр!

					Если содержит elementGetParamMap префикс 'AUTO_DISPATCH_CONTAINERFIELD_' - то все свойства объекта, с данными, element_model 
						выностятся из самого объекта на уровень выше. Код который это делает api/methods.php:84

					Как устроены Collapse-ы:
						...

					Во все компоненты надо будет добавить поле 
						findId:			[String] 		В него вставляется значение elementGetParamMap, потом можно вызвать поиск GetElementByParamMap

					Обязательные свойства при описании поля:
						elementGetParamMap:	[String] 		Название параметры которое будет передано в АПИ
						element_model: 		[Что угодно] 		Входные/выходные данные компонента
						elementType: 		[String] 		Тип поля для отрисовке в интерфейсе

					Не обязательные свойства:
						elementID:		[String] 		Зарезервировано непонятно для чего, но зарезервировано
						elementCat:		[String] 		Название справочника, например для выпадающего списка в селекте
						label:			[String] 		Заголовок для компонента/поля
						placeholder:		[String] 		Placeholder для компонента/поля
						*options:		[Array]			Массив объектов для отрисовки выпадающего списка или группы переключателей, формат может быть разным
							для Селектов:		[{value: '1', label: 'Да',},{value: '0', label: 'Нет',}]
							для переключателей:	[{name: '1', label: 'Да',},{name: '0', label: 'Нет',}]
					
					Depricated поля для ФОРМ:
						element_model_default - используется в фильтре, в ФОРМАХ не нужен

					Типы полей:
						1) label
							- Просто надпись каконо-нибудь значения:
								смысл записи: значение записи
							- Входные параметры:
								placeholder					смысл записи
								element_model	[String]		значение записи
							- Выходные параметры: 
								Нет
						2) input
							- Поле ввода
							- Входные параметры:
								label
								placeholder
								element_model	[String]||[Number]
							- Выходные параметры:
								v-model поля в element_model
						3) input-hidden
							- Скрытое поле. Имеет смысл для передачи дополнительных параметров при сохранении формы
							- Входные параметры:
								element_model	[String]||[Number]
							- Выходные параметры:
								v-model поля в element_model, т.е равны v-model входных параметров
						4) textarea
							- Многострочное текстовое поле ввода 
							- Входные параметры:
								label
								placeholder
								element_model	[String]||[Number]
							- Выходные параметры:
								v-model поля в element_model
						5) radio-group
							- Группа переключателей
							- Входные параметры:
								label
								element_model	[String]||[Number]
								options		[Array]
									такого формата [{name: '1', label: 'Да',},{name: '0', label: 'Нет',}]
							- Выходные параметры:
								v-model поля в element_model
						6) input-contact
							- Специальный компонент для ввода контактных данных
							- Входные параметры:
								label
								placeholder
								element_model		[Array]		Массив объектов описывающих контактные данные
									такого формата [{contact_id: '',contact_type: '',contact_value: '',contact_view: '', contact_group:'phone'}]
									особенности: если contactGroup не подразумевает contactGroup_options, тогда contact_type надо проставить заранее при генерации
								delMethod		[Object]	Объект запроса к АПИ на удаление контакта
									такого формата {apiMethod:'DEL_CONTACT',apiParam:{obj:'staff',flt:{code:'',contact_id:''}}}
								contactGroup		[String]	Тип контакта, для валидации и группировки
									принимает значения 'phone'||'email'||'web'||'social'||'messanger'
								contactGroup_options	[Array]
									такого формата [{value: '1', label: 'Да',},{value: '0', label: 'Нет',}]
							- Выходные параметры:
									v-model поля в element_model
						7) select
							- Список выбора параметров
							- Входные параметры:
								element_model 	[String]||[Array]	фиксация выбора, [Array] когда multiselect=true
								filterable	[Boolean]		Параметр позволяет осуществлять поиск по опциям
								multiple	[Boolean]		Параметр позволяет выбрать более одного значения
								options		[Array]
									такого формата [{value: '1', label: 'Да',},{value: '0', label: 'Нет',}]
						8) input-date
							- Выбор даты. Отображаемый формат dd.MM.yyyy
							- Входные параметры:
								element_model	[String]	Дата
						9) input-date-range
							- Выбор даты промежутком От - До. Отображаемый формат dd.MM.yyyy
							- Входные параметры:
								elementGetParamMap	[String]	ОСОБЕННОСТЬ: оба поля через разделитель вот так ПАРАМЕТР_ОТ|ПАРАМЕТР_ДО, например: 'sds|sde'
								range_separator		[String]	Символ между полями дат
								start_placeholder	[String]	placeholder для первого поля От
								end_placeholder		[String]	placeholder для второго поля До
								element_model		[Array]
									такого формата ['startDt':'','endDt':'']
						10) input-datetime
							- Выбор даты и времени. Отображаемый формат dd.MM.yyyy HH:mm:ss
							- Входные параметры:
								element_model	[String]	Дата время, в формате yyyy-MM-dd HH:mm:ss
						11) input-time
							- Выбор даты и времени. Отображаемый формат HH:mm
							- Входные параметры:
								element_model	[String]	Дата время, в формате HH:mm:ss
						12) input-time-range
							- Выбор времени промежутком От - До. Отображаемый формат HH:mm
							- Входные параметры:
								elementGetParamMap	[String]	ОСОБЕННОСТЬ: оба поля через разделитель вот так ПАРАМЕТР_ОТ|ПАРАМЕТР_ДО, например: 'sts|ste'
								range_separator		[String]	Символ между полями времени
								start_placeholder	[String]	placeholder для первого поля От
								end_placeholder		[String]	placeholder для второго поля До
								element_model		[Array]
									такого формата ['startDt':'','endDt':'']
						13) checkbox
							- Одиночная галочка
							- Входные параметры:
								placeholder	[String]	ОСОБЕННОСТЬ: Это левый лэйбл для галочки
								label		[String]	Это основной лейбл галочки
								element_model	[Boolean]	Оно же идёт в checked
						14) checkbox-group
							- Группа галочек
							- Входные параметры:
								elementGetParamMap	[String]	Перечисление всех имен параметров через разделитель, например 'vm_fst|vm_snd|vm_trd'
								label			[String]	Текст для группы, левый лейбл
								element_model		[Object]	Немного сложно, НО: имя свойства это ключ в options
									такого формата {vm_fst:false,vm_snd:true,vm_trd:false}
								options	[Array]
									такого формата [{key:'vm_fst',label:'первый'},{key:'vm_snd',label:'второй'},{key:'vm_trd',label:'третий',disabled:true},]
										key		[String]	связь со свойством в element_model, а так же значение параметра для фильтра и АПИ запроса
										label		[String]	Надпись у галочки
										disabled	[Boolean]	Отклюяает взаимодействие с галочкой. Если не передавать равен false.
						15) list
							- Чисто отображение списком
							- Входные параметры:
								element_model	[Array]		Специальный формат с children-ами
							- Выходные параметры: 
								Нет
						16) select-tree
							- Список выбора параметров для древовидных структур, например: структура организации
							- Входные параметры:
								element_model	[Array]	
									такого формата ['inputText':'', 'selectedVal':'']
						17) switcher
							- Переключатель типа On/Off
							- Входные параметры:
								element_model	[Boolean]
						18) task-ends
							- Компонент для БП/Услуги, помогает рисовать стрелки исходы
							- Входные параметры:
								element_model	[Array] массив объектов такой структуры:
									{
										TASK_ID: '',		// Id задачи
										name: '',		// Имя исхода
										end_type: '',		// тип завершения, из списка специальных типов для завершения текущей задачи
										tto: '',		// Куда ведёт после завершения
										act: true,		// актуальна ли задача
										ttype:'', 		// какой исход: положительный или отрицательный = GOOD/OTHER
									}
								type_options	[Array] Список Тип завершения
								next_options	[Array] список Задача после завершения
								tType_options	[Array] Виды исходов радио группой
							- Выходные параметры: 
								те же что для element_model
						19) input-actions	/не доделан/
							... 
						20) upload-docs
							- Компонент для загрузки вспомогательных/обучающих документов к задаче
							- Входные параметры:
								element_model	[Array] массив объектов такой структуры:
									{
										id: '',		// id документа, если это создание нового документа - то пусто
										name: '',	// Название документа
										descr: '',	// Описание документа
										link: '',	// ССылка на документ
										act: '',	// Актуален ли документ
									}
								limit		[Number] максимальное количество добавляемых документов
							- Выходные параметры: 
								те же что для element_model
						21) file-upload	/ обновить описание /
							- Загрузка файлов на сервер. На текущий момент умеет грузить в режиме type="file"
							- Входные параметры:
								type		[String]	(""|avatar|file)
								multiple	[Boolean]
								formId		[String]
								btnClass	[Object]	класс для кнопки и иконки. такого формата:
									{
										btn:'btn btn-icon btn-simple btn-info',
										icon:'tim-icons icon-attach-87'
									}
								bShowTrash	[Boolean]
								acceptMime	[String]
							- Выходные параметры:
								пока непонятно
						22) ajax-list
							- выпадающий список чего-либо подходящего под фильтр текста введённого для поиска
							- Входные параметры:
								element_model	[Object] объект такой структуры:
									{
										inputText: '',	// строка текста для отображения
										selectedVal:''	// конкретное значение, наример id
									}
								objApiMethod	[Object]	объект описывающий метод поиска
									например: array('obj'=>'address' ,'flt'=>array('addr'=>''))
								strApiMethodKey	[String]	вспомогательный обязательный параметр, подсказывает в какой параметр метода подставлять набранный текст
									например: 'addr'
								strType		[String]	бывает staff||address.addr , нужен для превращения данных от апи в выпадающий список
							- Выходные параметры: 
								те же что для element_model
						23) input-number
							- Поле ввода чисел
							- Входные параметры:
								label
								placeholder
								element_model	[Number]
								minValue - минимально допустимое число
								maxValue - максимально допустимое число
							- Выходные параметры:
								v-model поля в element_model
						24) ajax-list-tags
							- выпадающий список чего-либо подходящего под фильтр текста введённого для поиска с тегами и мультивыбором
							- Входные параметры:
								element_model	[Object] объект такой структуры:
									{
										inputText: '',	// строка текста для отображения
										selectedVal:''	// конкретное значение, наример id
									}
								objApiMethod	[Object]	объект описывающий метод поиска
									например: array('obj'=>'address' ,'flt'=>array('addr'=>''))
								strApiMethodKey	[String]	вспомогательный обязательный параметр, подсказывает в какой параметр метода подставлять набранный текст
									например: 'addr'
								objSaveApiMethod	[Object]	объект описывающий метод и парметры срабатывающий при изменении в компоненте
								strType		[String]	бывает staff||address.addr , нужен для превращения данных от апи в выпадающий список
							- Выходные параметры: 
								те же что для element_model
						25) place - пока не применяется, возможно не работает.
							- множественный выбор Район/направление/метро/карта
							- Входные параметры:
								label
								element_model	[Object]
									- формата
										{
											districts: {all:[]},
											directions: {all: []},
											metro: {all:[]},
											map: {}
										}
								objSaveApiMethod ?????
							- Выходные параметры: 
								те же что для element_model
						26) passport-upload
							...
						27) fromMetro
							...
						28) urgency
							...
						29) re-curator
							...
						30) show-clientmobile
							...
						31) select-cascade
							...
						32) input-amount
							- Специальный инпут для денег, разделяет октеты
							- Входные параметры:
								label
								placeholder
								element_model	[String]
							- Выходные параметры: 
								те же что для element_model
						33) input-ajaxsearch-distrmetro
							...
						34) staff-notify-conf - требует доработки возможности отключения уведомлений
							- Нужен для подключения уведомлений сотруднику
							- Входные параметры:
								label
								placeholder
								element_model	[Object]
									- формата
										{
											activate_link,	//ссылка для подключения уведомлений
											is_send			//отправлять ли уведомления
										}
							- Выходные параметры: 
								те же что для element_model
						35) list-of-people
							- Поля для описания клиента в чеклисте ДДУ
							- Входные параметры:
								label
								element_model	[Array]
									- каждый элемент формата
										{
											surname:'', 	//Фамилия
											name:'',		//Имя
											patronymic:'',	//Отчество
											phones:[],		//массив телефонов
											emails:[],		//мвссих емайлов
											state:0			//в браке или нет, 0 - в браке
										}
							- Выходные параметры: 
								те же что для element_model
						34) input-inn
							- Поле ввода ИНН
							- Входные параметры:
								label
								placeholder
								element_model	[Number]
							- Выходные параметры:
								v-model поля в element_model		
						35) rating
							- Поле оценки работы исполнителя
							- Входные параметры:
								label								
								element_model	[Number]
							- Выходные параметры:
								v-model поля в element_model	
						32) input-decimal
							- Специальный инпут для вещественных чисел. Пока 2 знака после запятой.
							- Входные параметры:
								label
								placeholder
								element_model	[String]
							- Выходные параметры: 
								те же что для element_model															
						33) select-railway
							- специальный компонент для ввода ЖД станции, на вход получает region или external_params_value[MapAddress]
							- Входные параметры:
								label
								placeholder
								element_model	[String]
							- Выходные параметры: 
								те же что для element_model									
						34) select-blank-service
							- специальный компонент для ввода кода услуги в бланки армана
							- Входные параметры:
								label
								placeholder
								element_model	[String]
							- Выходные параметры: 
								те же что для element_model
						35) map-location
						    - Компонент для выбора координат на карте
							- входные параметры:
						        element_model  [Array]
							- Выходные параметры: 
								те же что для element_model
						36) select-region-district
						- Компонент для выбора Региона и района из справочника
							- входные параметры:
						        element_model  [Array]
							- Выходные параметры: 
								те же что для element_model
						37) select-cascade-arman
										...
						38) marketing-export
							- компонент для выбора куда выгружается текущий сайт
				</pre>
			</div>
		</div>
	</div>
</template>

<script>
	
	import { TimeSelect, DatePicker, Select, Option, Rate, Popover, ColorPicker } from 'element-ui';
	import { BaseCheckbox, BaseRadio, BaseSwitch } from 'src/components/index';
	import ReTreeSearchDrop from 'src/our_components/ReTreeSearchDrop.vue';
	import ReDateRange from 'src/our_components/ReDateRange.vue';
	import ReTimeRange from 'src/our_components/ReTimeRange.vue';
	import ReInputContact from 'src/our_components/ReInputContact.vue';
	import ReBranchTree from 'src/our_components/BranchTree/ReBranchTree.vue';
	import ReTaskEnds from 'src/our_components/ReTaskEnds.vue';
	import ReActionInput from 'src/our_components/ReActionInput.vue';
	import ReUploadDocs from 'src/our_components/ReUploadDocs.vue';
	import ReFileUpload from 'src/our_components/ReFileUpload.vue';
	import ReImagesUpload from 'src/our_components/ReImagesUpload.vue';
	import ReInputSearchDrop from 'src/our_components/ReInputSearchDrop.vue';
	import ReTagGroupList from "src/our_components/ReTagGroupList.vue";
	import ReFromMetro from "src/our_components/ReFromMetro.vue";
	import ReUrgency from "src/our_components/ReUrgency.vue";
	import RePlace from 'src/our_components/RePlace.vue';
	import ReCurator from 'src/our_components/ReCurator.vue';
	import RePassportPhotos from 'src/our_components/RePassportPhotos.vue';
	import ReShowClientMobile from 'src/our_components/ReShowClientMobile.vue';
	import ReSelectCascade from 'src/our_components/ReSelectCascade.vue';
	import ReSelectCascadeArmanNB from 'src/our_components/ReSelectCascadeArmanNB.vue';
	import ReSelectRegionDistrict from 'src/our_components/ReSelectRegionDistrict.vue';
	import ReInputAmount from 'src/our_components/ReInputAmount.vue';
	import ReInputDecimal from 'src/our_components/ReInputDecimal.vue';
	import ReInputINN from 'src/our_components/ReInputINN.vue';
	import ReInputINNUr from 'src/our_components/ReInputINNUr.vue';
	import ReInputSNILS from 'src/our_components/ReInputSNILS.vue';
	import ReInputBICUr from 'src/our_components/ReInputBICUr.vue';
	import ReInputSearchDistrMetro from 'src/our_components/ReInputSearchDistrMetro.vue';
	import ReStaffNotifyConf from 'src/our_components/ReStaffNotifyConf';
	import ReReassignExtCalls from 'src/our_components/ReReassignExtCalls';	
	import ReListOfPeople from "src/our_components/ReListOfPeople.vue";
	import ReSelectSovmestService from 'src/our_components/ReSelectSovmestService.vue';
	import ReSelectBlankServices from 'src/our_components/ReSelectBlankServices.vue';
	import ReFlatListForBron from 'src/our_components/ReFlatListForBron.vue';
	import ReFioPadej from 'src/our_components/ReFioPadej.vue';
	import RePassportFull from 'src/our_components/RePassportFull.vue';
	import ReClientAddress from 'src/our_components/ReClientAddress.vue';
	import ReCellMapEditor from 'src/our_components/ReCellMapEditor.vue';
	import ReSelectCascadeObjCategory from 'src/our_components/ReSelectCascadeObjCategory.vue';
	import ReMapAddress from 'src/our_components/ReMapAddress.vue';
	import ReMapLocation from 'src/our_components/ReMapLocation.vue';
	import ReInputMask from 'src/our_components/ReInputMask.vue';
	import ReContactMessangersTemplate from 'src/our_components/ReContactMessangersTemplate.vue';
	import ReCellByAddr from 'src/our_components/ReCellByAddr.vue';
	import ReCheckListFields from 'src/our_components/ReCheckListFields.vue';
	import ReLeadSearchObj from 'src/our_components/ReLeadSearchObj.vue';
	import ReMessengersTemplate from 'src/our_components/ReMessengersTemplate.vue';
	import ReLeadCallCat from 'src/our_components/ReLeadCallCat.vue';
	import ReSquareCost from 'src/our_components/ReSquareCost.vue'; 
	import ReInputRailway from 'src/our_components/ReInputRailway.vue';
	import ReLeadServices from 'src/our_components/ReLeadServices.vue';
	import ReStaffNotificationList from 'src/our_components/ReStaffNotificationList';
	import ReInputRoomSum from 'src/our_components/ReInputRoomSum';
	import ReUsefulSquare from 'src/our_components/ReUsefulSquare';
	import ReSharePercent from 'src/our_components/ReSharePercent';
	import ReSelectScheduleServices from 'src/our_components/ReSelectScheduleServices.vue';
	import BaseDateTimePicker from 'src/our_components/datetimepickers/BaseDateTimePicker.vue';
	import RePresentaionMyObjButton from 'src/our_components/RePresentaionMyObjButton.vue';
	import FormElementWrapper from './FormElementWrapper.vue';
	import ReMarketingExport from '../ReMarketingExport.vue';
	
	
	export default {
		name: 'ReFormPrinterOptions',
		components: {
			[DatePicker.name]: DatePicker,
			[TimeSelect.name]: TimeSelect,
			[Option.name]: Option,
			[Select.name]: Select,
			[Rate.name]: Rate,
			[Popover.name]: Popover,
			[ColorPicker.name]: ColorPicker,
			BaseCheckbox,
			BaseRadio,
			ReTreeSearchDrop,
			ReDateRange,
			ReTimeRange,
			ReInputContact,
			BaseSwitch,
			ReBranchTree,
			ReTaskEnds,
			ReActionInput,
			ReUploadDocs,
			ReFileUpload,
			ReImagesUpload,
			ReInputSearchDrop,
			ReTagGroupList,
			ReFromMetro,
			ReUrgency,
			RePlace,
			ReCurator,
			RePassportPhotos,
			ReShowClientMobile,
			ReSelectCascade,
			ReSelectCascadeArmanNB,
			ReSelectRegionDistrict,
			ReInputAmount,
			ReInputDecimal,
			ReInputINN,
			ReInputINNUr,
			ReInputSNILS,
			ReInputBICUr,
			ReInputSearchDistrMetro,
			ReStaffNotifyConf,
			ReReassignExtCalls,
			ReListOfPeople,
			ReSelectSovmestService,
			ReSelectBlankServices,
			ReFlatListForBron,
			ReFioPadej,
			RePassportFull,
			ReClientAddress,
			ReCellMapEditor,
			ReSelectCascadeObjCategory,
			ReMapAddress,
			ReMapLocation,
			ReInputMask,
			ReContactMessangersTemplate,
			ReCellByAddr,
			ReCheckListFields,
			ReLeadSearchObj,
			ReLeadCallCat,
			ReSquareCost,
			ReInputRailway,
			ReLeadServices,
			ReMessengersTemplate,
			ReStaffNotificationList,
			ReInputRoomSum,
			ReUsefulSquare,
			ReSharePercent,
			ReSelectScheduleServices,
			BaseDateTimePicker,
			RePresentaionMyObjButton,
			FormElementWrapper,
			ReMarketingExport,
		},
		props: {
			opt: Object,
			isCollapseItem:{
				type: Boolean,
				default: false
			},
			frmAllConfig: Array,
			isCheckList:{
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				ver: 1,
				bUploading: false,
				isShown: true,
				fullscreenLoading: false,
				photo_model: {
					degree:0,
					isMain:false,
					fullpath:''
				}
			}
		},
		watch:{
			opt(newValue){
				this.initChange(newValue.elements)
			}
		},
		computed: {
			
		},
		methods: {
			initChange(elements){
				elements.map(el=>this.change(el))
			},
			canSkip_change(element){
				if(element.canSkip_model===true)element.required=false;
				else element.required=true;
				//console.log(element);
			},
			// showObjSearch(data){
			// 	//console.log('bIsShown showObjSearch',this.bIsShown);
			// 	return true;
			// },
			fixNumber(element){
				// меняем в числах запятую на точку.
				element.element_model = String(element.element_model).replace(',','.');

				if(element.minValue && element.minValue !=undefined  && element.minValue >= 0 ){ 
					if(element.element_model<0){
						element.element_model = element.element_model * -1; //дедлаем значение положительным, если мы очень хотим и специально указали 'minValue'=>'0' или >0
					}
				}
				if(element.floor){
					element.element_model = String(Math.floor(element.element_model))
				}
			},
			contr(cur_el){
				return false;
			},
			CheckOption(el){
				if(el.element_model == null){
					if(el.elementType == 'radio-group'){el.element_model = '0';}
					else{el.element_model = '';}
				}
				if(el.elementType == 'task-ends'){
					if(el.element_model.length > 0){
						for (let i = 0; i < el.element_model.length; i++) {
							if(el.element_model[i].act == '1'){
								el.element_model[i].act = true;
							}else{
								el.element_model[i].act = false;
							}
						}
					}
				}
				if(el.elementType == 'checkbox'){
					if(typeof el.element_model == 'string'){
						el.element_model= el.element_model=='0'?false:true;
					}
				}
				return '';
			},
			OnAjaxListSearch(opt){

			},
			OnUploadFile(objUpload){
				// console.log('OnUploadFile',objUpload);  //return false;
				//if(objUpload == null) return false;
				if(objUpload != null){
					if(typeof objUpload.selfObj != 'undefined'){
						if(!this.$GVO.isEmpty(objUpload.selfObj.uploadApi)){
							this.bUploading=true;
							this.fullscreenLoading = true;
							// const objIndex = objUpload.formId.match(/[0-9/.]+/)[0];
							// console.log(objUpload.formId,objUpload.selfObj.uploadApi,objUpload.selfObj.uploadApi.apiParam);
							this.$GVO.UploadFile(objUpload.formId, objUpload.selfObj.uploadApi.apiMethod, objUpload.selfObj.uploadApi.apiParam)
								.then(objApi => {
									// console.log('OnUploadFile',objApi);
									if(objApi.success){
										this.fullscreenLoading = false;
										if(this.GetElementByParamMap(objUpload.selfObj.findId) !== false){
											if(this.GetElementByParamMap(objUpload.selfObj.findId).element_model == '') this.GetElementByParamMap(objUpload.selfObj.findId).element_model = [];
											if(typeof this.GetElementByParamMap(objUpload.selfObj.findId).element_model == 'string'){
												let dmpEl = this.$GVO.unlinkObject(this.GetElementByParamMap(objUpload.selfObj.findId).element_model);
												if(dmpEl != '/img/placeholder.jpg'){
													this.GetElementByParamMap(objUpload.selfObj.findId).element_model = [];
													this.GetElementByParamMap(objUpload.selfObj.findId).element_model.push(dmpEl);
													//this.GetElementByParamMap(objUpload.selfObj.findId).src_filenames = [];
												}else{
													this.GetElementByParamMap(objUpload.selfObj.findId).element_model = [];
													this.GetElementByParamMap(objUpload.selfObj.findId).src_filenames = [];
												}
											}
											if(typeof objApi.data.fullpath !='undefined'){
												// console.log(this.GetElementByParamMap(objUpload.selfObj.findId));
												if(this.GetElementByParamMap(objUpload.selfObj.findId).elementType=='image-upload'){
													let tmpPhoto = this.$GVO.unlinkObject(this.photo_model);
													tmpPhoto.fullpath = objApi.data.fullpath;
													this.GetElementByParamMap(objUpload.selfObj.findId).element_model.push(this.$GVO.unlinkObject(tmpPhoto));
												}else{
													this.GetElementByParamMap(objUpload.selfObj.findId).element_model.push(objApi.data.fullpath);
												}
												if(typeof objApi.data.src_filename !='undefined' && this.GetElementByParamMap(objUpload.selfObj.findId).src_filenames !='undefined'){
													this.GetElementByParamMap(objUpload.selfObj.findId).src_filenames.push(objApi.data.src_filename);
												}
											}else if(objApi.data.length>0){
												let tmpPhoto = this.$GVO.unlinkObject(this.photo_model);
												for (let ip = 0; ip < objApi.data.length; ip++) {
													if(this.GetElementByParamMap(objUpload.selfObj.findId).elementType=='image-upload'){
														tmpPhoto.fullpath = objApi.data[ip].fullpath;
														this.GetElementByParamMap(objUpload.selfObj.findId).element_model.push(this.$GVO.unlinkObject(tmpPhoto));
													} else {
														this.GetElementByParamMap(objUpload.selfObj.findId).element_model.push(objApi.data[ip].fullpath);
													}
													if(typeof objApi.data.src_filename !='undefined' && this.GetElementByParamMap(objUpload.selfObj.findId).src_filenames !='undefined'){
														this.GetElementByParamMap(objUpload.selfObj.findId).src_filenames.push(objApi.data[ip].src_filename);
													}
												}
											}
										}
										/*
										if(typeof this.GetElementByParamMap(objUpload.selfObj.findId).element_model.length != 'undefined' && this.GetElementByParamMap(objUpload.selfObj.findId).element_model.length == 1){
											let dmpEl2 = this.$GVO.unlinkObject(this.GetElementByParamMap(objUpload.selfObj.findId).element_model[0]);
											this.GetElementByParamMap(objUpload.selfObj.findId).element_model = dmpEl2;
										}
										*/
									}else{
										this.$GVO.showAlert('Загрузка файлов',objApi.msg);
									}
									this.bUploading=false;
									this.fullscreenLoading = false;
								})
								.catch(errorObjApi => 	{  console.error(errorObjApi); this.bUploading=false; this.fullscreenLoading = false;});
						}
					}else if(typeof objUpload === 'string'){
						if(this.GetElementByParamMap(objUpload) !== false){
							this.GetElementByParamMap(objUpload).element_model = '';
						}
					}
				}
			},
			GetElementByParamMap(strParamMap){
				for (let i = 0; i < this.frmAllConfig.length; i++) {
					for (let iEl = 0; iEl < this.frmAllConfig[i].elements.length; iEl++) {
						if(typeof this.frmAllConfig[i].elements[iEl].elementGetParamMap != 'undefined'){
							if(this.frmAllConfig[i].elements[iEl].elementGetParamMap == strParamMap){
								return this.frmAllConfig[i].elements[iEl];
							}
						}
					}
				}
				return false;
			},
			OnBronFields(objFlat){
				objFlat = this.$GVO.unlinkObject(objFlat);
				//console.log(objFlat);
				//console.log(this.frmAllConfig[1].elements);
				const masFieldMap = [
					//{'elementGetParamMap из конфига':'поле из objFlat'},
					{'gk_data':'gk_name_tr'},
					{'gk_data':'b_corp'},
					{'gk_data':'app_section'},
					{'flat_number':'app_number'},
					{'room_count':'app_rooms'},
					{'amount':'app_baseflatcost'},
					// Поля для ДДУ
					{'object_number':'app_number'},
					{'object_floor':'app_flatfloor'},
					{'object_square':'app_stotal'},
					{'pay_price_base':'app_baseflatcost'},
					{'pay_price_disc':'app_flatcostwithdiscounts'},
				];
				for (let i = 0; i < masFieldMap.length; i++) {
					const elementGetParamMap = Object.keys(masFieldMap[i])[0];
					const flat_field = masFieldMap[i][elementGetParamMap];
					const element=this.GetElementByParamMap(elementGetParamMap);
					// Нет поля ну и ...ладно, найдём другое.
					if(!element) continue;
					//console.log(elementGetParamMap,flat_field,this.GetElementByParamMap(elementGetParamMap),objFlat[flat_field]);
					if(elementGetParamMap=='gk_data'&& flat_field=='gk_name_tr'){
						element.element_model.gk_name_tr=objFlat[flat_field];
					}else if(elementGetParamMap=='gk_data'&& flat_field=='b_corp'){
						element.element_model.gk_block=objFlat[flat_field];
					}else if(elementGetParamMap=='gk_data'&& flat_field=='app_section'){
						element.element_model.gk_sections=objFlat[flat_field];
					}else if(elementGetParamMap=='amount'&& flat_field=='app_baseflatcost'){
						element.element_model=this.$GVO.number_format(objFlat[flat_field],0,'.',' ');
					}else{
						element.element_model=objFlat[flat_field];
					}
				}
			},
			OnIsObjects(opt){},
			// cancalReadOnly(onOff) {
            //     this.$nextTick(() => {
            //         if (!onOff) {
            //             const {select} = this.$refs;
            //             const input = select.$el.querySelector('.el-input__inner');
            //             input.removeAttribute('readonly');
            //         }
            //     });
            // }
			changeVisible(list, status){
				if(list && list.length){
					// console.log(status?'отображаем':'скрываем', list)
					this.opt.elements.forEach(el=>{
						if(list.indexOf(el.elementGetParamMap)>-1)
							//console.log('hide',el.elementGetParamMap)
							if(el.auto_show != status){
								el.auto_show=status
								this.changeVisible(el.old_show, status)
							}
					})
				}

			},
			/**
			 * Управляет отображением/скрытием других полей
			 * @param {*} element 
			 */
			change(element){
				this.$emit('value-change',{element});
				// console.log('change',element && element.elementGetParamMap, element);
				if(element.show_fields){
					// Получаем из вида 1:field1,field2,2:field3,field4 массив поиска
					// v[0] - это значение до :, совпадающее с выбранным значением в компоненте element_model
					// debugger;
					const element_model=String(element.element_model); // Сделаем строкой для логических значений
					const tmp=element.show_fields.split(';').map(v=>v.split(':')).find(v=>v[0]==element_model);
					this.changeVisible(element.old_show, false)
					element.old_show=[];
					if(tmp && tmp[1]){
						element.old_show=tmp[1].split(',')
					}
					this.changeVisible(element.old_show, true);
					/*
					if(element.old_show.length>0){
						this.opt.elements.forEach(el=>{
							if(element.old_show.indexOf(el.elementGetParamMap)>-1){
								//console.log('show',el.elementGetParamMap)
								el.auto_show=true
							}
						})
					}
					*/
					//console.log('element', element, element.old_show);
				}
			},
			activateField(name){
				if(this.$refs[name]){
					this.$emit('show-panel');
					let el = this.$refs[name][0];
					setTimeout(function(){
						
						let input = el.querySelector('input');
						if(input)input.focus();
						el.scrollIntoView({
							block:'center'
						});
						/*
						setTimeout(()=>{
							// console.log('add')
							el.classList.add('error');
							setTimeout(()=>{
								// console.log('remove');
								el.classList.remove('error');
							},3000)
						},100)
						*/
					},500)
					return true;
				}
			}
		},
		mounted(){
			try{
				this.initChange(this.opt.elements)
			}catch(e){}
		},
		created(){
		}
	}
</script>
<style scoped>
	.title{
		text-transform: uppercase;
	}
	.form-options-group > .row{
		flex-direction: column;
		margin-bottom: 15px;
		margin-left: 0px!important;
	}

	
	
	.form-param-group.input-number-group, .input-number{margin-bottom: 20px;}
	.form-param-group > *{display: inline-block; margin-right: 10px;}
	.btn-outline-info.is-active{
		background-color: #51bcda !important;
		color: rgba(255, 255, 255, 0.8) !important;
		border-color: #51bcda !important;
	}
	.form-param-group.input-number-group .group-control-label{display: block !important; margin-bottom: 5px;}
	.input-number > label{display: block !important;}
	.input-number > .el-input-number{width: 100%;}

	.form-options-group{
		display: flex;
		flex-direction: column;
		width: 49%;
		vertical-align: top;
	}
	/* .form-options-group{
		display: inline-block;
		width: 49%;
		vertical-align: top;
	} original with col-md-12*/

	.form-options-group:nth-child(odd){
		margin-right: 10px;
	}
	.form-options-group .btn-round{padding: 8px;}

	.super_conteiner{margin-bottom: 10px;}

	.check-list{
		top: -15px;
    	position: relative;
	}
	.formRequired span:first-child {position: relative; width: fit-content;}
	/* .formRequired span:first-child::before{
		display: inline-block;
		position: absolute;
		content: '*';
		color: crimson;
		font-size: 14px;
		right: -10px;
		top: 2px;
	} */
	
	.form-options-group >>> .SelectCascade-col {
		display: flex;
		flex-direction: column;
	}
	.ReCardServiceAdd .form-options-group .row {margin-bottom: 5px;}
	.DescrNumber {font-size: 12px; color:#01b0e0; /*padding-left: 15px;*/ margin-top: 2px;}
	/* .form-options-group .col-form-label {margin-bottom: 5px;} */
	.hohoho {color: #F84E54;}
	
	/*media*/
	@media (max-width: 700px){
		.form-options-group .btn-round{padding: 5px;}
	}
	@media (max-width: 670px){
		.form-options-group{
			display: block;
			width: 100%;
		}
		.form-options-group:nth-child(odd){
			margin-right: 0px;
		}
		.form-options-group:nth-child(even){
			order: 10;
		}
	}
	@media (max-width: 610px){
		.form-options-group .btn-round{padding: 8px;}
	}
	@media (max-width: 420px){
		.form-options-group .btn-round{padding: 5px;}
		.form-options-group {padding: 0;}
	}
	div.elementWrapper{
		transition: background-color 1s;
	}
	div.elementWrapper.error{
		background-color: red;
	}

</style>
